/* ============================================================
   SAVRAA — diagnostics. Silent unless a flag is in the URL.

     ?svdebug=1    list every element wider than the viewport
     ?svdebug=cod  dump the COD popup's field structure
     ?svdebug=btn  list the buy / COD buttons and where they lead
   ============================================================ */
(function () {
  'use strict';

  var m = location.search.match(/[?&]svdebug=([a-z0-9]+)/i);
  if (!m) return;
  var mode = m[1].toLowerCase();

  var tag = 'background:#D92D20;color:#fff;padding:2px 6px;border-radius:3px';

  /* ---------- overflow ---------- */
  function scanOverflow(){
    var docW = document.documentElement.clientWidth;
    var offenders = [];

    document.querySelectorAll('body *').forEach(function(el){
      var r = el.getBoundingClientRect();
      if (r.width === 0 && r.height === 0) return;
      if (Math.round(r.right) <= docW + 1 && Math.round(r.left) >= -1) return;

      var p = el.parentElement, inRail = false;
      while (p && p !== document.body) {
        var ov = getComputedStyle(p).overflowX;
        if (ov === 'auto' || ov === 'scroll' || ov === 'hidden' || ov === 'clip') { inRail = true; break; }
        p = p.parentElement;
      }
      if (inRail) return;

      offenders.push({
        el: el,
        tag: el.tagName.toLowerCase(),
        cls: (el.className && el.className.toString().slice(0, 70)) || '',
        left: Math.round(r.left),
        right: Math.round(r.right),
        width: Math.round(r.width),
        overBy: Math.round(Math.max(r.right - docW, -r.left))
      });
    });

    offenders.sort(function(a, b){ return b.overBy - a.overBy; });
    console.log('%c[savraa] viewport ' + docW + 'px \u2014 ' + offenders.length + ' overflowing', tag);
    if (offenders.length) {
      console.table(offenders.map(function(o){
        return { tag:o.tag, cls:o.cls, left:o.left, right:o.right, width:o.width, overBy:o.overBy };
      }));
      offenders.slice(0, 12).forEach(function(o){
        o.el.style.outline = '2px solid #D92D20';
        o.el.style.outlineOffset = '-2px';
      });
      console.log('[savraa] worst:', offenders[0].el);
    }
  }

  /* ---------- COD popup structure ---------- */
  function dumpCod(){
    var tels = document.querySelectorAll('input[type="tel"],input[name*="phone" i],input[name*="mobile" i]');
    if (!tels.length) {
      console.log('%c[savraa] No COD form in the DOM yet.', tag);
      console.log('Open the COD popup first, then re-run: svcod()');
      return;
    }

    tels.forEach(function(t, idx){
      var form = t.closest('form') || t.closest('div[class]');
      if (!form) return;

      console.log('%c[savraa] COD form #' + (idx + 1), tag);
      console.log('container:', form.tagName.toLowerCase(), '.' + (form.className || '(no class)'));
      console.log('action:', form.getAttribute('action') || '(none)');

      var rows = [];
      form.querySelectorAll('input,select,textarea').forEach(function(el){
        var lbl = '';
        if (el.id) {
          var l = document.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(el.id) : el.id) + '"]');
          if (l) lbl = l.textContent.trim().slice(0, 40);
        }
        rows.push({
          tag: el.tagName.toLowerCase(),
          type: el.type || '',
          name: el.getAttribute('name') || '',
          id: el.id || '',
          required: el.required,
          label: lbl,
          parentCls: (el.parentElement && el.parentElement.className || '').toString().slice(0, 45)
        });
      });
      console.table(rows);

      var btns = [];
      form.querySelectorAll('button,[type="submit"]').forEach(function(b){
        btns.push({
          text: (b.textContent || '').trim().slice(0, 45),
          type: b.getAttribute('type') || '',
          cls: (b.className || '').toString().slice(0, 55)
        });
      });
      console.table(btns);

      console.log('outer classes (first 3 ancestors):',
        [form.parentElement, form.parentElement && form.parentElement.parentElement,
         form.parentElement && form.parentElement.parentElement && form.parentElement.parentElement.parentElement]
          .filter(Boolean).map(function(n){ return n.tagName.toLowerCase() + '.' + (n.className || ''); }));
    });
  }

  /* ---------- buttons ---------- */
  function dumpButtons(){
    console.log('%c[savraa] buy / COD buttons', tag);
    var rows = [];
    document.querySelectorAll('button, a.button, input[type="submit"], [class*="cod" i], [class*="buy" i]').forEach(function(b){
      var txt = (b.textContent || '').trim().slice(0, 40);
      if (!txt) return;
      rows.push({
        text: txt,
        tag: b.tagName.toLowerCase(),
        cls: (b.className || '').toString().slice(0, 60),
        href: b.getAttribute('href') || '',
        formAction: b.getAttribute('formaction') || (b.form && b.form.getAttribute('action')) || '',
        onclick: b.getAttribute('onclick') ? 'yes' : ''
      });
    });
    console.table(rows);
  }

  function run(){
    if (mode === 'cod') dumpCod();
    else if (mode === 'btn') dumpButtons();
    else scanOverflow();
  }

  // Exposed so you can re-run after opening the popup.
  window.svcod = dumpCod;
  window.svbtn = dumpButtons;
  window.svfit = scanOverflow;

  if (document.readyState === 'complete') setTimeout(run, 500);
  else window.addEventListener('load', function(){ setTimeout(run, 500); });

  window.addEventListener('resize', function(){
    if (mode !== '1') return;
    clearTimeout(window.__svdebugT);
    window.__svdebugT = setTimeout(scanOverflow, 300);
  });

  console.log('%c[savraa] debug ready \u2014 svcod() / svbtn() / svfit()', 'background:#111;color:#fff;padding:2px 6px;border-radius:3px');
})();
